/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import LogModel from 'cio/models/log';

interface ActivityLogRowNameArgs {
  log: LogModel;
}

export default class ActivityLogRowName extends Component<ActivityLogRowNameArgs> {}
